import { RT } from '../theme/retentionTheme';
import { InfoList, SectionCard, SoftChip } from './ui';

// Hand-off from CRM — context for stage 1 (Verify basics), not a stage of its own. Read-only, filled by
// the system. Field names follow getAllCRMLeadsUpdated (RETENTION_WORKFLOW.md §5.5); syllabus comes from the header API.
export default function FromCrmCard({ student }) {
  const aed = student?.currency_type === 'AED';
  const fee = aed ? student?.collected_fee_aed : student?.collected_fee_inr;

  return (
    <SectionCard
      icon="solar:hand-shake-bold-duotone"
      color={RT.info}
      title="From CRM"
      action={<SoftChip label="auto" icon="solar:bolt-bold" color={RT.info} />}
    >
      <InfoList
        rows={[
          { icon: 'solar:hashtag-square-linear', label: 'Adm No', value: student?.admn_no },
          { icon: 'solar:book-bookmark-linear', label: 'Course', value: student?.assigned_course_name },
          { icon: 'solar:notebook-linear', label: 'Syllabus', value: student?.syllabus },
          { icon: 'solar:layers-minimalistic-linear', label: 'Sessions', value: student?.total_session_count },
          { icon: 'solar:tag-price-linear', label: 'Sale', value: student?.total_sales_amount },
          { icon: 'solar:wallet-money-linear', label: 'Collected', value: fee != null ? `${student?.currency_type || ''} ${fee}`.trim() : null },
          { icon: 'solar:calendar-linear', label: 'First fee', value: student?.first_fee_payment_date },
          { icon: 'solar:user-id-linear', label: 'CRM', value: student?.assigned_by },
          { icon: 'solar:clock-circle-linear', label: 'Assigned', value: student?.cro_assigned_on },
        ]}
      />
    </SectionCard>
  );
}
